/**
 * ShippingSection Component
 * Section untuk Opsi Pengiriman dengan alamat, waktu pengiriman, dan catatan
 */

import { Box, Stack, useDisclosure } from '@chakra-ui/react';
import type { ShipmentDates } from '@diamond/sol-buyer/utils';
import { useFormContext } from 'react-hook-form';

import { ContactEditModal } from './ContactEditModal';
import { DeliveryNotesModal } from './DeliveryNotesModal';
import { ShippingAddressCard } from './ShippingAddressCard';

export interface ShippingSectionProps {
  shipmentDates?: ShipmentDates;
  onDeliveryChange?: (shippingTier: string, deliveryOption: string) => void;
}

/**
 * Main Shipping Section Component
 * Menampilkan opsi pengiriman, alamat, dan catatan pengiriman
 */
export function ShippingSection({
  shipmentDates,
  onDeliveryChange,
}: ShippingSectionProps) {
  const { watch } = useFormContext();

  // Delivery Notes Modal
  const {
    isOpen: isNotesOpen,
    onOpen: onNotesOpen,
    onClose: onNotesClose,
  } = useDisclosure();

  // Contact Edit Modal
  const {
    isOpen: isContactOpen,
    onOpen: onContactOpen,
    onClose: onContactClose,
  } = useDisclosure();

  // Watch form values
  const deliveryDate = watch('delivery_date');
  const deliveryOption = watch('delivery_option');
  const deliveryNote = watch('delivery_note');
  const shipToName = watch('ship_to.name');
  const shipToAddress = watch('ship_to.address');
  const shipToContactName = watch('ship_to_contact.name');
  const shipToContactTelp = watch('ship_to_contact.telp');

  return (
    <Box>
      <Stack spacing={4}>
        {/* Section Title */}
        {/* <Text fontSize="2xl" fontWeight="bold" color="gray.900">
          Opsi Pengiriman
        </Text> */}

        {/* All-in-One Card: Address, Contact, and Delivery Time */}
        <ShippingAddressCard
          address={shipToAddress}
          shipToName={shipToName}
          contactName={shipToContactName}
          contactPhone={shipToContactTelp}
          deliveryOption={deliveryOption}
          shipmentDates={shipmentDates}
          onNotesClick={onNotesOpen}
          onEditContact={onContactOpen}
          onDeliveryChange={onDeliveryChange}
        />
      </Stack>

      {/* Delivery Notes Modal */}
      <DeliveryNotesModal
        isOpen={isNotesOpen}
        onClose={onNotesClose}
        deliveryOption={deliveryOption}
        currentNote={deliveryNote}
      />

      {/* Contact Edit Modal */}
      <ContactEditModal isOpen={isContactOpen} onClose={onContactClose} />
    </Box>
  );
}
